import { IApplicationState } from '../../types/redux';

export const selectAgreementOffer = (state: IApplicationState) => state.legalCheck.agreementOffer;
